import "../config";
import axios from "axios";
var apiUrl = global.platformURI;



export const fethcAllGenericDemographic = async () => {
    try {
        // let data = await axios.get(apiUrl + `/api/v1/generic_questions/demographic_questions`)
        let data = await axios.get(apiUrl + `/api/v1/survey_questions/demographic_questions`)

        // dispatch(fetchAssessmentMurkQuestions(data.data))    // fetch Data for questionlist
        return {
            data: data?.data,
            status: data?.status
        }
    }
    catch (error) {
        return {
            message: error.response.data.errors || 'somthing went wrong.',
            status: 500
        }
    }

}

export const fetchGenericDemographicQuestions = () =>{
    return {
        type: 'FETCH_DEMOGRAPHIC_QUESTIONS',
        method: 'get',
        URLEndPoint: 'FETCH_GENERIC_DEMOGRAPHIC_QUESTIONS',
        axiosService: true,
        toaster: {
            loading: true
        }
    }
}



export const fetchFeedBackAndQuestionsData = (groupByParam) => {
    return {
        type: 'FETCH_FEEDBACK_QUESTIONS',
        method: 'get',
        URLEndPoint: 'FETCH_GENERIC_FEEDBACK_QUESTIONS',
        params:{group : groupByParam},
        axiosService: true,
        toaster: {
            loading: true
        }
    }
}

export const submitGenericDemographicsQuestions = (payload) => {
    return {
        type: 'SUBMIT_GENERIC_DEMOGRAPHICS_QUESTIONS',
        method: 'post',
        URLEndPoint: 'SUBMIT_GENERIC_DEMOGRAPHICS_QUESTIONS',
        data: payload,
        axiosService: true,
        toaster: {
            loading: true
        }
    }
}

export const submitGenericQuestionsDemographics = async (payload, groupByPayload) => {
    try {
        // /api/v1/survey_responses
        // /api/v1/generic_responses
        // let data = await axios.post(apiUrl + '/api/v1/generic_responses', { generic_response: payload, ...groupByPayload })
        let data = await axios.post(apiUrl + '/api/v1/survey_responses', { survey_response: payload, ...groupByPayload })

        return {
            data: data?.data,
            status: data?.status
        }

    }
    catch (error) {
        return {
            error: error,
            status: 500
        }
    }
}

export const submitFeedBackQuestion = (payload, byUrl,) => {
    return {
        type: 'FEEDBACK_QUESTIONS_RESPONSES',
        method: 'post',
        URLEndPoint: 'GENERIC_FEEDBACK_QUESTIONS_RESPONSES',
        data: payload,
        axiosService: true,
        toaster: {
            loading: true
        }
    }
}